module.exports = __webpack_public_path__ + "static/bug-without-monotonic-reads-a1a062b4af6155714e08769a2a9d0ca4.png";